import { render, staticRenderFns } from "./WaitingMatch.vue?vue&type=template&id=7a522abd&scoped=true"
import script from "./WaitingMatch.vue?vue&type=script&lang=js"
export * from "./WaitingMatch.vue?vue&type=script&lang=js"
import style0 from "./WaitingMatch.vue?vue&type=style&index=0&id=7a522abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a522abd",
  null
  
)

export default component.exports